export const REPUTATION = {
    title: '中国大地财产保险股份有限公司',
    subtitle: '家庭财产保险<br>附加房屋出租声誉受损津贴保险条款',
    register_number: '（注册号：C00001032122018073010862）',
    protocols: [
        {
            intro: '保险责任',
            list: [
                {
                    order: '第一条',
                    context: '在保险期间内，在主险保险单载明地址的房屋（以下简称“被保险房屋”）出租期间，被保险房屋内发生影响房屋出租声誉的下列事件的，保险人按照本附加险合同载明的保险金额负责赔偿：',
                    details: [
                        { text: '（一）自杀造成人员非正常死亡；' },
                        { text: '（二）犯罪行为造成人员非正常死亡。' }
                    ]
                }
            ]
        },
        {
            intro: '责任免除',
            list: [
                {
                    order: '第二条',
                    context: '下列任何原因造成的损失、费用，保险人不负责赔偿：',
                    details: [
                        { text: '（一）被保险人及其家庭成员、家政服务人员、暂居人员的故意行为、重大过失行为；' },
                        { text: '（二）被保险房屋非用于出租期间发生人身死亡事件。' }
                    ]
                },
                {
                    order: '第三条',
                    context: '下列损失、费用，保险人不负责赔偿：',
                    details: [
                        { text: '（一）保险单载明的免赔额或按照保险单载明的免赔率计算的免赔额；' },
                        { text: '（二）其他不属于本保险责任范围内的损失、费用。' }
                    ]
                }
            ]
        },
        {
            intro: '保险金额',
            list: [ { order: '第四条', context: '本附加险的保险金额由投保人与保险人协商确定，并在保险单中载明。' } ]
        },
        {
            intro: '其他事项',
            list: [ { order: '第五条', context: '本附加险条款未尽事宜，以主险条款的约定为准；本附加险条款与主险条款若有相抵触之处，以本附加险条款的约定为准。' } ]
        }
    ]
}